var React = require('react');

function ArrowLeftInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"arrow-left.inline"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Artboard","transform":"translate(-226.000000, -149.000000)","fill":"#000000","fillRule":"nonzero"},React.createElement("g",{"id":"arrow-left.inline","transform":"translate(236.000000, 159.000000) scale(-1, 1) translate(-236.000000, -159.000000) translate(226.000000, 149.000000)"},React.createElement("polygon",{"id":"▶","points":"0 20 20 10 0 0"}))))]);
}

ArrowLeftInline.defaultProps = {"width":"20px","height":"20px","viewBox":"0 0 20 20","version":"1.1"};

module.exports = ArrowLeftInline;

ArrowLeftInline.default = ArrowLeftInline;
